import React from 'react'
import { SidePanel } from '@node-space/ui-components'
import { Card } from 'services/CardService'
import { CustomerWallet } from 'types/customers'
import { CardDetailsSidePanelBody } from './CardDetailsSidePanelBody'
import { CardDetailsSidePanelHeader } from './CardDetailsSidePanelHeader'

interface CardDetailsSidePanelProps {
  isOpen: boolean
  onClose: () => void
  card?: Card
  wallet?: CustomerWallet
  onFreeze?: () => void
}

export const CardDetailsSidePanel = ({
  isOpen,
  onClose,
  card,
  wallet,
  onFreeze,
}: CardDetailsSidePanelProps) => {
  return (
    <SidePanel
      id="card-details-side-panel"
      isOpen={isOpen}
      onClose={onClose}
      bodyScrollable={false}
      header={card && wallet ? <CardDetailsSidePanelHeader card={card} wallet={wallet} /> : null}
      body={card ? <CardDetailsSidePanelBody card={card} onFreeze={onFreeze} /> : null}
    />
  )
}
